import gb2 from "../../../assets/Product_img/gb_II/1.jpg";
import gb21 from "../../../assets/Product_img/gb_II/2.jpg";
import first from "../../../assets/Product_img/common/1.jpeg";
import second from "../../../assets/Product_img/common/2.jpeg";
import third from "../../../assets/Product_img/common/3.jpeg";
import four from "../../../assets/Product_img/common/4.jpeg";
import five from "../../../assets/Product_img/common/5.jpeg";
export const proLabGB2 = {
  hero: {
    title: "Pro-Lab ",
    title2:"GB II",
    description:
      "Reliable inert-atmosphere glove box designed for routine laboratory and research applications.",
      imgUrl:
    gb2
  },
  
  productsDetails: {
    imgList: [
      gb2,gb21,first,second,third,four,five
    ],

    productName: "Pro-Lab GB II Glove Box",

    description:
      "The Pro-Lab GB II glove box is engineered for laboratories requiring stable inert conditions for handling air-sensitive materials. It provides consistent oxygen and moisture control, making it ideal for academic research, material science, and small-scale industrial applications.",

    keyFeatures: [
      "Low oxygen and moisture levels (<5 ppm)",
      "Single-station inert atmosphere chamber",
      "Efficient gas purification system",
      "Compact footprint for laboratory environments",
      "Integrated antechamber for material transfer",
    ],

    download: {
      title: "Download Brochure PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Product Description",
    briefDescirption:
      "The Pro-Lab GB II Glove Box offers a dependable solution for routine inert-atmosphere operations. Its compact design, ease of operation, and stable performance make it well-suited for universities, R&D labs, and entry-level industrial research facilities.",
  },
};
